import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { RowColumnValue } from '../../../device-management/model/settings-definition/row.column.value.type';

@Component({
  selector: 'ls-form-row-column-select',
  templateUrl: 'ls-form-row-column-select.component.html'
})
export class LsFormRowColumnsSelectComponent {
  @Input()
  public description: string;
  @Input()
  public disabled: boolean;
  @Input()
  public key: string;
  @Input()
  public max: RowColumnValue;
  @Input()
  public title: string;
  @Input()
  public value: RowColumnValue;
  @Input()
  public visible: boolean;
  @Input()
  public form: FormGroup;
}
